import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import Meter from './meter';
import MeterDetail from './meter-detail';
import MeterUpdate from './meter-update';
import MeterDeleteDialog from './meter-delete-dialog';

const MeterRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<Meter />} />
    <Route path="new" element={<MeterUpdate />} />
    <Route path=":id">
      <Route index element={<MeterDetail />} />
      <Route path="edit" element={<MeterUpdate />} />
      <Route path="delete" element={<MeterDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default MeterRoutes;
